import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default function init() {
  const tagFeedEl = document.querySelector('.tag-feed')
  const count = tagFeedEl ? parseInt(tagFeedEl.dataset.count, 10) : 0

  const additionalOptions =
    count > 3
      ? {
          centeredSlides: true,
          loop: true,
          breakpoints: {
            1024: {
              slidesPerView: 2,
              slidesPerGroup: 1,
            },
          },
        }
      : {
          breakpoints: {
            1024: {
              slidesPerView: count > 1 ? 2 : count,
              slidesPerGroup: count > 1 ? 1 : count,
            },
          },
        }

  // eslint-disable-next-line no-new
  new Swiper('.swiper', {
    modules: [Navigation, Autoplay],
    slidesPerView: 1,
    slidesPerGroup: 1,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    ...additionalOptions,
  })
}
